import React, { useMemo } from 'react';
import { useGetDocumentsInfinite } from '@area-restrita/api-client/endpoints/company-document/company-document.gen';

import Select, { ISelectProps, SelectOption } from '../Select';

type IProps = Omit<ISelectProps, 'options'> & {
  allowsChangeRequest?: boolean;
};

const DocumentSelector = React.forwardRef<HTMLInputElement, IProps>(
  ({ allowsChangeRequest, ...props }, _ref) => {
    const query = useGetDocumentsInfinite(
      { limit: 100, page: 1, allowsChangeRequest },
      {
        query: {
          queryKeyHashFn: (args) => JSON.stringify(['infinite', ...args]),
          getNextPageParam: (lastPage, _, lastPageParam) =>
            lastPage.data.length > 0 ? lastPageParam + 1 : null,
        },
      },
    );

    const documents = useMemo(
      () =>
        query.data?.pages.flatMap<SelectOption>((page) =>
          page.data.map((doc) => ({
            label: doc.name,
            value: doc.publicId,
          })),
        ) ?? [],
      [query.data],
    );

    return (
      <Select
        placeholder="Selecione um documento"
        plural="documentos"
        {...(props as ISelectProps)}
        options={documents}
      />
    );
  },
);

export default DocumentSelector;
